export const SOURCE_TYPES = {
  OFFER: 'offer',
  GUEST_OFFER: 'guestOffer',
  SEARCH: 'search',
  GUEST_SEARCH: 'guestSearch',
  METASEARCH: 'metasearch',
  CHECKOUT: 'checkout',
  CHANGE_DATES: 'changeDates',
  INIT_CHECKOUT: 'initCheckout',
  TOUR_TILE: 'tourTile',
  INIT_MOBILE_FLIGHT_CHECKOUT: 'initMobileFlightCheckout',
  CTA: 'cta',
  LOGGEDIN_METASEARCH: 'loggedInMetasearch',
  CUG_METASEARCH: 'cugMetasearch',
  METASEARCH_SESSION: 'metasearchSession',
  CUG_METASEARCH_SESSION: 'cugMetasearchSession',
  METASEARCH_PRICE_VERIFIER: 'metasearchPriceVerifier',
} as const
